import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import useWindowSize from "../../hooks/useWindowSize";
import Tippy from "@tippyjs/react";
import OrderCancelModal from "./reusableComponents/CancelOrderModal";
import Popup from "../../ReusableFunctions/Popup";
import { cancelLeadOrder, cancelRequest, getLeadOrderDetails, getRequest } from "../../apis/requests";
import { QUEUE_ORDER_STATUS, STATUS } from "../../appConstants";
import { Button } from "../../Components/Helper";
import { useSelector } from "react-redux";
import MainContentWrapper from "../../Components/MainContentWrapper";
import Loading from "../../ReusableFunctions/Loader";
import dateFormat from 'dateformat';

const OperationsLeadOrdersDetails = () => {
    const { state } = useLocation();
    const [request, setRequest] = useState()
    const [userExists, setUserExists] = useState(false)
    const navigate = useNavigate();
    // const [cancelNote, setCancelNote] = useState("");
    const [fieldInfo, setFieldInfo] = useState(
        { lat: 19.993982, lng: 73.790416, status_history: [] }
    )
    const [fieldData, setFieldData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const { user } = useSelector((state) => state.user);
    const { currentWidth } = useWindowSize();
    const [openCancelOrderModal, setOpenCancelOrderModal] = useState(false);

    const Field = ({ label, value, overflow }) => (
        <div className='single_field_wrapper'
            style={{ cursor: label === "Customer Name" || label === "Contact No." ? "pointer" : "default", lineHeight: overflow ? 1.15 : 1.1 }}
            onClick={() => {
            }}
        >
            <div className='single_field_label' style={{ display: "flex", gap: "0.8rem" }} >
                <p>{label}</p>
            </div>
            <div className='single_field_value' style={{
                maxHeight: overflow && value?.length > 120 ? "100px" : "none",
                overflowY: overflow && value?.length > 120 ? "auto" : "hidden"
            }}>
                {value || "-"}
            </div>
        </div>
    );

    // function getFieldValue(field, value) {

    //     switch (field) {
    //         case 'Sales by':
    //             if (value == "Bes") {
    //                 return "BhuMeet Store"
    //             } else if (value == "Customer support engineer") {
    //                 return 'Customer Success Engineer'
    //             } else if (value === 'SYSTEM') {
    //                 return 'Rebrodcasted by System'
    //             } else if (value === 'Farmer') {
    //                 return 'Farmer'
    //             } else if (value === "Admin") {
    //                 return "Admin"
    //             }
    //     }
    // }

    useEffect(() => {
        if (request) {
            const fieldData1 = [
                { label: 'Sales by', value: request?.sales_by },
                { label: 'Request Number', value: request?.req_number },
                { label: 'Customer Name', value: request?.user_name },
                { label: 'Contact No', value: request?.user_phone },
                { label: 'Service Location', value: request?.field_address, overflow: true },
                { label: 'Crop', value: request?.crop_name || "-" },
                { label: 'Pesticide', value: request?.pesticide, overflow: true },
                { label: 'Created On', value: dateFormat(request.date_created, "dd/mm/yyyy") || "-" },
                { label: 'Schedule On', value: dateFormat(request.time, "dd/mm/yyyy") || "-" },
                { label: 'Status', value: request?.status === QUEUE_ORDER_STATUS.CANCELLEDBYFARMER || request?.status === QUEUE_ORDER_STATUS.MISSEDBYFARMER ? "Cancelled by Farmer" : request?.status === QUEUE_ORDER_STATUS.CANCELLEDBYOPRATIONS ? "Cancelled by Operations" : request?.status ? request?.status : "Placed" },
                { label: 'Note', value: request?.note || "-" },
            ].filter(Boolean);
            setFieldData(fieldData1)
        }
    }, [request])

    const getRequestDetails = async () => {
        let order = await getLeadOrderDetails(state?.request?.id, true)
        setRequest(order)
    }

    const cancelRequestFunction = async (requestId, note) => {
        console.log("cancelRequestFunction called with ::", { requestId, note })
        try {
            await cancelLeadOrder(requestId, note)
            setOpenCancelOrderModal(false);
            getRequestDetails()
            Popup.alert("Request cancelled", "Request successfully cancelled!", 'SUCCESS',)
        } catch (e) {
            Popup.alert("Error", e, "ERROR");
        }
    }

    useEffect(() => {
        Loading.set(true)
        getRequestDetails()
        Loading.set(false);
    }, [])

    return (<><MainContentWrapper >
        {
            <OrderCancelModal
                open={openCancelOrderModal}
                onClose={() => {
                    setOpenCancelOrderModal(false);
                }}
                onOrderCancel={async (cancelOrderReason) => {
                    if (request?.is_bes_linked) {
                        Popup.alert("BES linked", "Are you want to debit BES incentive ?", "WARNING", () => cancelRequestFunction(request.id, cancelOrderReason, true), null, "Yes", () => cancelRequestFunction(request.id, cancelOrderReason, false), "No")
                    }
                    else cancelRequestFunction(request.id, cancelOrderReason, false)
                }}
            />
        }

        <div style={{ background: "white", height: "100%", width: "100%", }}>
            <div
                style={{
                    position: "relative",
                    width: "100%",
                    height: "12%",
                    padding: "20px 30px",
                    borderBottom: "1px solid rgba(128, 128, 128, 0.24)",
                    fontSize: "1rem",
                    display: "flex",
                    justifyContent: "space-between", // This aligns left and right
                    alignItems: "center",
                    color: "#1E1E1E",
                    fontWeight: "500",
                }}
            >
                {/* Left content */}
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div>Request Details</div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "20px" }}>

                        {(![STATUS.COMPLETED, STATUS.PAID, STATUS.CANCELLED, QUEUE_ORDER_STATUS.CANCELLEDBYFARMER, QUEUE_ORDER_STATUS.CANCELLEDBYOPRATIONS, QUEUE_ORDER_STATUS.MISSEDBYFARMER, QUEUE_ORDER_STATUS.EXPIRED].includes(request?.status)) && state.request?.showCancel && <>
                            <Button
                                // isDisabled={!cancelNote}
                                text={"Cancel"}
                                className={"btn-large"}
                                onClick={() => {
                                    setOpenCancelOrderModal(true);
                                }}
                            />
                        </>}
                    </div>
                </div>
            </div>

            <div style={{ background: "white", position: "relative", display: "flex", width: "100%", height: "92%" }}>
                <div style={{ width: "80%", height: "auto", overflowY: "scroll", borderRight: "1px solid #8080803d" }}>
                    <div style={{ position: "relative", padding: "20px 30px", height: "auto", overflowY: "scroll", width: "100%", }}>
                        <div className='request_fields_wrapper'>
                            {fieldData.map((field, index) => (
                                <Field key={index} label={field.label} value={field.value} overflow={field.overflow} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </MainContentWrapper > </>);
};
export default OperationsLeadOrdersDetails;